import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { chain } from 'lodash';
import CharactersSpeciesDetail from '@/pages/Characters/CharactersSpeciesDetail.vue';
import CharacterBuilderSpeciesAbilities from './CharacterBuilderSpeciesAbilities.vue';
let CharacterBuilderSpecies = class CharacterBuilderSpecies extends Vue {
    get speciesChoices() {
        return chain(this.species)
            .sortBy('contentType')
            .map('name')
            .value();
    }
    get currentSpeciesData() {
        return this.species.find(({ name }) => name === this.currentSpecies.name);
    }
    handleChangeSpecies(newSpecies) {
        this.$emit('replaceCharacterProperty', {
            path: 'species',
            property: {
                name: newSpecies,
                abilityScoreImprovementSelectedOption: 0,
                abilityScoreImprovement: {}
            }
        });
    }
};
__decorate([
    Prop(Array)
], CharacterBuilderSpecies.prototype, "species", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderSpecies.prototype, "currentSpecies", void 0);
CharacterBuilderSpecies = __decorate([
    Component({
        components: {
            CharactersSpeciesDetail,
            CharacterBuilderSpeciesAbilities
        }
    })
], CharacterBuilderSpecies);
export default CharacterBuilderSpecies;
